import React, { useEffect } from 'react';
import { useModal } from '../common/context/ModalProvider';
import { ButtonType } from '../common/types/Buttons';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { useDialog } from '../common/hooks/useDialog';

const ConfirmDialog = () => {
  const { isConfirmDialogOpen, confirmDialogContent, hideConfirmDialog } = useDialog();
  const { title, description, buttons }: any = confirmDialogContent;

  useEffect(() => {
    if (confirmDialogContent?.shouldAutoClose) {
      setTimeout(() => {
        hideConfirmDialog();
      }, 3000);
    }
  }, [confirmDialogContent?.shouldAutoClose, isConfirmDialogOpen]);

  if (!isConfirmDialogOpen) return null;

  return (
    <Dialog open={isConfirmDialogOpen}>
      <DialogContent className='z-[100] flex aspect-square flex-col items-center justify-center rounded-xl border-transparent bg-transparent p-0'>
        <main className='flex w-[80vw] flex-col rounded-xl bg-white dark:bg-neutral-800 p-0'>
          <section className='bg-neutral-100 dark:bg-neutral-900 p-4 rounded-tl-xl rounded-tr-xl'>
            <h2 className=' text-center font-bold'>{title}</h2>
          </section>
          <section className='p-4'>
            <p className='text-center text-foreground-500 mb-6'>{description}</p>
            {buttons?.map(
              ({
                title,
                variant,
                onClick,
                closesModal,
              }: {
                title?: string;
                variant?: ButtonType['variant'];
                onClick?: () => void;
                closesModal?: boolean;
              }) => {
                return (
                  <Button
                    key={title}
                    variant={variant ? variant : 'default'}
                    className='mt-3 block w-full'
                    onClick={() => {
                      if (closesModal) hideConfirmDialog();
                      if (onClick) onClick();
                    }}
                  >
                    {title}
                  </Button>
                );
              }
            )}
          </section>
        </main>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmDialog;
